<div class="col-md-12">
    <!--modal-dialog-container-800-->
    <div class="modal-dialog-header">
        <div class="container">
            <br>

            <div class="row">
                <div class="col-md-12">
                    <!-- <mat-label style="color: white;">Digite el NIT del colectivo</mat-label>-->
                    <mat-label style="color: #0372b9;">Ingrese el valor de la cuota de inscripción correspondiente</mat-label>
                    <mat-form-field appearance="outline">
                        <!-- <input [(ngModel)]="form.nit.value" matInput #message minlength="7" maxlength="10"
                            placeholder="#">-->
                        <input style="color: #0372b9;" id="txtNumero" (keyup)="validarValor($event, 'nit')" [(ngModel)]="form.nit.value" matInput
                            #message placeholder="#">
                        <!--<mat-icon matSuffix>search</mat-icon>-->
                        <mat-hint align="start" style="color:red">
                            <label>
                                {{error}}
                            </label>
                        </mat-hint>
                        <mat-hint align="end"><label>
                                {{message.value.length}} / 6
                            </label></mat-hint>

                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>

    <div class="modal-dialog-footer-b">

        <div class="modal-dialog-button" style="background-color:#0372b9 ;color: #fff ;"
            (click)="continuar(this.form.nit.value) ">Aceptar</div>

        <!--  <div class="modal-dialog-button"
            style="background-color:var(--main-gray-light-color);color:var(--main-app-color) ;"
            (click)="continuar(undefined) ">cancelar</div>-->
    </div>


</div>